import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 20v-15a1 1 0 0 1 1 -1h15","key":"svg-0"}]]

/**
 * IconBorderCornerSquare
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYm9yZGVyLWNvcm5lci1zcXVhcmUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMjB2LTE1YTEgMSAwIDAgMSAxIC0xaDE1IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/border-corner-square
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBorderCornerSquare = createReactComponent('outline', 'border-corner-square', 'BorderCornerSquare', __iconNode);

export default IconBorderCornerSquare;